import { render, staticRenderFns } from "./modifyPreDate.vue?vue&type=template&id=35c22cc5&scoped=true"
import script from "./modifyPreDate.vue?vue&type=script&lang=js"
export * from "./modifyPreDate.vue?vue&type=script&lang=js"
import style0 from "./modifyPreDate.vue?vue&type=style&index=0&id=35c22cc5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c22cc5",
  null
  
)

export default component.exports